import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: theme.palette.primary.main,
    },
 
    '& textarea': {
      minHeight: 80,
    },
  },
  alertTitle: {
    fontWeight: 'bold',
    fontSize: 14,
    paddingBottom: theme.spacing(0.5),
  },
}));
